<template>
  <div>
    <masonry
      :cols="{default: 3, 1000: 2, 400: 1}"
      :gutter="{default: '10px', 700: '5px'}"
    >
      <progressive-img-link
        id="pimg"
        v-for="(object, key) in albums"
        :src="getAlbumSrc(key, 1)"
        :alt="object.name"
        :placeholder="getImagePlaceholder(key, 1)"
        :key="key"
        :url="`/album/${key}`"
      />
    </masonry>
  </div>
</template>

<script>
  import albums from "../assets/albums.json";
  export default {
    name: "Gallery",
    methods: {
      getAlbumSrc: function(id, index) {
        let filename = `${index}`.padStart(4, "0");
        return `/albums/${id}/${filename}.jpg`;
      },
      getImagePlaceholder: function(id, index) {
        let filename = `${index - 1}`.padStart(4, "0");
        return `/albums/${id}/thumb_${filename}.jpg`;
      }
    },
    data() {
      return {
        albums
      };
    }
  };
</script>

<style scoped>
  @media screen and (min-width: 700px) {
    #pimg {
      width: 100%;
      margin-bottom: 10px;
    }
  }
  @media screen and (max-width: 700px) {
    #pimg {
      width: 100%;
      margin-bottom: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue